// https://vuex.vuejs.org/en/actions.html

import { MetierLocalStorage } from 'modulelocalstorage'

export default {
  // Déconnexion / Changement de PDV
  clear (context) {
    MetierLocalStorage.clear()

    context.commit('creditPermissions', '')
    context.commit('teleparameters', null)
    context.commit('shops', [])
    context.commit('listproducts', [])
    context.commit('consignes', [])
    context.commit('offline', false)
    context.commit('actionItems', null)
    context.commit('menuItems', [])
    context.commit('favoriteItem', null)
    context.commit('usepassword', false)
    // context.commit('favoriteScan', null)
  },
  partialClear (context) {
    MetierLocalStorage.partialClear()

    context.commit('teleparameters', null)
    context.commit('listproducts', [])
    context.commit('consignes', [])
    context.commit('offline', false)
    context.commit('actionItems', null)
    context.commit('menuItems', [])
    context.commit('favoriteItem', null)
    // context.commit('favoriteScan', null)
  },
  // GESTION DES PRODUITS
  addProduct ({ state }, index) {
    state.listproducts[index.i].products[index.j].quantity++
  },
  delProduct ({ state }, index) {
    if (state.listproducts[index.i].products[index.j].quantity > 0) {
      state.listproducts[index.i].products[index.j].quantity--
    }
  },
  setProductPrice ({ state }, data) {
    let product = state.listproducts[data.i].products[data.j]
    if (product.quantity > 0) {
      state.amount -= (product.quantity * product.price)
      product.quantity = 0
    }
    product.price = data.price
  },
  suppProduct ({ state }, index) {
    if (state.listproducts[index.i].products[index.j].quantity > 0) {
      state.listproducts[index.i].products[index.j].quantity = 0
    }
  },
  resetProducts ({ state }) {
    state.listproducts.forEach(list => {
      list.products.forEach(product => {
        if (product) {
          product.quantity = 0
          if (product.freeprice && product.price !== null) {
            product.price = null
          }
        }
      })
    })
    // Reset compteur ecocup
    state.consignes.forEach(el => {
      el.consigne.number = 0
      el.deconsigne.number = 0
    })
  },
  // ECOCUP
  addConsigne ({ state }, idConsigne) {
    const consigne = state.consignes.find(el => el.consigne.IDArticle === idConsigne)
    if (consigne !== undefined && (consigne.consigne.MaxConsigne === 0 || consigne.consigne.MaxConsigne > consigne.consigne.number)) {
      consigne.consigne.number++
      state.amount += consigne.consigne.PrixUnitaireTTC
    }
  },
  delConsigne ({ state }, idConsigne) {
    const consigne = state.consignes.find(el => el.consigne.IDArticle === idConsigne)
    if (consigne !== undefined && consigne.consigne.number > 0) {
      consigne.consigne.number--
      state.amount -= consigne.consigne.PrixUnitaireTTC
    }
  },
  addDeconsigne ({ state }, idConsigne) {
    const consigne = state.consignes.find(el => el.deconsigne.IDArticle === idConsigne)
    if (consigne !== undefined && (consigne.deconsigne.MaxConsigne === 0 || consigne.deconsigne.MaxConsigne > consigne.deconsigne.number)) {
      consigne.deconsigne.number++
      state.amount -= consigne.deconsigne.PrixUnitaireTTC
    }
  },
  delDeconsigne ({ state }, idConsigne) {
    const consigne = state.consignes.find(el => el.deconsigne.IDArticle === idConsigne)
    if (consigne !== undefined && consigne.deconsigne.number > 0) {
      consigne.deconsigne.number--
      state.amount += consigne.deconsigne.PrixUnitaireTTC
    }
  },
  // TRANSACTIONS
  setTransactions ({ state }, data) {
    state.transactions[data.type] = data.number
  },
  addTransaction ({ state }, type) {
    state.transactions[type]++
  },
  subtractTransactions ({ state }, data) {
    state.transactions[data.type] -= data.number
  },
  addCashlessTransaction ({ state }, amount = null) {
    state.transactions.cashlessCa += (amount !== null) ? amount : state.amount
    state.transactions.cashless += 1
  },
  // PAX INFOS
  setPaxMerchant ({ state }, merchant) {
    state.neptingInfos.merchantId = merchant
  },
  setPaxServer ({ state }, server) {
    state.neptingInfos.server = server
  },
  setPaxToken ({ state }, token) {
    state.neptingInfos.token = token
  },
  setPaxOffline ({ state }, offline) {
    state.neptingInfos.offline = parseInt(offline)
  }
}
